
// region JS Imports
import $ from "jquery"
// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import Modal from "app/modal/show-modal"
import Google_Event from "app/tracking/google/event"
// Private Modules

// region Public Components
import ImageLazyLoading from "widgets/image_lazyloading"

import DataRetriever from "app/data_retriever/lite"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


import RequestBox from "concepts/listings/contact/request/box/index"
import Track_ee from "concepts/listings/contact/request/box/components/tracking/index"

const CELL_CLASS_NAME = "cell-listing-contact-request-modal"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`
const PAGE_TYPE_ID_FOR_TRACKING = DataRetriever.get("page-type-id-for-tracking") as string

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    RequestBox.init()
    ImageLazyLoading.default_lazyload_instance().update()
  })

  $(`.${CELL_CLASS_NAME}`).on("hide.bs.modal" , () => {
    Google_Event.track({
      category: PAGE_TYPE_ID_FOR_TRACKING,
      action:   "Enquiry",
      options:  {
        eventLabel: "Enquiry - Enquiry Form Dismissed",
      },
    })
  })
}

const loadAndShowModal = (data: string) => {
  Modal.showModalWithContent(
    data,
    {
      customContent: true,
    },
  )
  init()
  Track_ee.emit("modal_show")
}

export default {
  init,
  loadAndShowModal,
}
